<template>

    <div class="common-layout">
        <el-container>
            <el-header class="common-header flex-float">
                <div class="flex">
                    <img class="logo" src="../../assets/icon.png" alt="">
                    <h1 class="title">贝贝舒母婴-杨浦店合同签订系统</h1>
                </div>
                <div class="header-right">
                    <div class="head-user">
                        <div class="user_account">
                            <el-icon>
                                <User />
                            </el-icon>
                            {{ userInfo.userAccount }}
                        </div>
                    </div>

                    <el-button type="primary" @click="logout">退出</el-button>
                </div>
            </el-header>
            <el-container class="content_container">
                <el-main><router-view></router-view></el-main>
                <el-footer class="footer">
                    <span class="beian" @click="goToLink">沪ICP备2024062418号-2</span>
                </el-footer>
            </el-container>
        </el-container>
    </div>
</template>

<script>
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { reactive, toRefs } from 'vue'

export default {
    name: "layout",
    setup() {
        const store = useStore()
        const data = reactive({
            userInfo: store.state.uInfo.userInfo
        })
        const router = useRouter()
        const logout = () => {
            localStorage.removeItem("loginData")
            store.commit("setUserInfo", {})
            router.push({
                path: "/login"
            })
        }

        const goToLink = () => {
            window.open('https://beian.miit.gov.cn')
        }

        return {
            ...toRefs(data),
            logout,
            goToLink
        }
    }
}
</script>

<style>
.el-container {
    height: 100vh;
}

.common-header {
    background: rgb(29, 33, 39);
    display: flex
}

.common-aside {
    background: rgb(48, 55, 65);
}

.logo {
    width: 80px;
}

.title {
    color: #fff;
    font-size: 12px;
}

.el-main {
    background: #efefef
}

.header-right {
    display: flex;
    color: #fff;
    align-items: center;
    justify-content: center;
}

.head-user {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #6a5d5d6d;
    padding: 15px;
    margin-right: 10px;

}


.head-role {
    font-size: 12px;
}

.content_container {
    height: calc(100vh - 60px);
}

.footer {
    background: #efefef;
    display: flex;
    height: 40px !important;
}
</style>